<template>
  <!-- The one spinner: a green ring. Inline next to what's busy (a switch
       saving, a search running); `block` centers it in an area that has no
       shape to sketch (a map), with an optional line under it. Content that
       loads gets a skeleton instead (KbSkeletonRows / Table / Cards). -->
  <div
    v-if="block"
    class="kb-loading"
    role="status"
    :aria-label="label"
  >
    <span
      class="kb-spinner kb-spinner-lg"
      aria-hidden="true"
    />
    <span
      v-if="text"
      class="kb-loading-text"
    >{{ text }}</span>
  </div>
  <span
    v-else
    class="kb-spinner"
    :class="`kb-spinner-${size}`"
    role="status"
    :aria-label="label"
  />
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  /** What's loading, for screen readers */
  label?: string
  size?: 'sm' | 'md' | 'lg'
  block?: boolean
  text?: string
}>(), { label: 'Loading', size: 'sm', block: false, text: '' })
</script>
